import {getCurrentYear} from '../../utils/commons'
import TheBestKitchenPicksLogo from './logo'
import theBestKitchenPicksStyles from './styles'

const baseConfig = {
  domainName: 'thebestkitchenpicks' as const,
  domainType: 'picks' as const,
  siteName: 'The Best Kitchen Picks',
  favicon: '/favicons/thebestkitchenpicks.png',
  logo: <TheBestKitchenPicksLogo className="size-9 shrink-0 tablet:size-7" />,
  styles: theBestKitchenPicksStyles,
}

const localeConfigs = {
  us: {
    measurementId: 'G-65WVX0F6TW',
    camelCaseUrl: 'TheBestKitchenPicks.com',
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in the US | TheBestKitchenPicks.com - Reviews & Guides`,
    description: (_category?: string, _count?: string) =>
      `Discover the best kitchen products with TheBestKitchenPicks.com. Our expert team provides curated lists, detailed product reviews, and key feature insights to help you select the perfect additions for your kitchen in ${getCurrentYear()}`,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
